import React from 'react'
import { components } from 'cng-web-lib'
import { Grid } from '@material-ui/core'
import FormProperties from './FormProperties'
import pathMap from 'src/paths/PathMap_SCOJMCustomAttr'
import CustomAttributeUrls from "../../../apiUrls/sco-jm-custom-attr/CustomAttributeUrls";


const {
  form: { CngAddForm }
} = components

function AddPage({ history, showNotification }) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CngAddForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          history={history}
          showNotification={showNotification}
          bodySection={
            <FormProperties.Fields
              disabled={false}
              showNotification={showNotification}
            />
          }
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: CustomAttributeUrls.CUSTOM_ATTR_CREATE,
            successRedirect: pathMap.SCO_JM_CUSTOM_ATTR_LIST_VIEW
          }}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage
